import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@fontsource/ibm-plex-sans-arabic/400.css";
import "@fontsource/ibm-plex-sans-arabic/500.css";
import "@fontsource/ibm-plex-sans-arabic/600.css";
import "./design/global.css";
import { App } from "./app/App";
import { installDownloadBridge } from "./lib/saveFile";
import { installCrashReports } from "./app/crashGuard";

/*
 * Download links the app does not own — the demonstration boards build their
 * own and click them — routed through the viewer's save capability when the
 * app is running inside it. A no-op in a browser, where the links work.
 */
installDownloadBridge();
/* a fault anywhere is written to the platform's log, so it names itself */
installCrashReports();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
